<template>
    <span
            class="q10__square mx-1"
            :class="['bg-gradient-to-r', 'from-' + options.from, 'to-' + options.to,  options.from, options.to]"
    >
    </span>
</template>

<script>
export default {
    name: "Square",
    props: {
        options: null,
    },
};
</script>

<style lang="scss" scoped>
.q10__square {
    display: inline-block;
    width: 10px;
    height: 10px;
}
</style>
